module.exports = __webpack_public_path__ + "img/ico-plan-free.5b42d0b8.svg";